// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__WgZ0F","loading_container":"Loading_loading_container__F6vZd","loading_spinner":"Loading_loading_spinner__VaMM2","spin":"Loading_spin__s3iqi"};